@if ((loginInitiated$ | async) || !loginConfig) {
    <app-spinner-overlay></app-spinner-overlay>
} @else {
    <div
            class="login-container"
            [style.backgroundImage]="'url(' + (loginConfig.backgroundUrl || defaultBackgroundImageUrl) + ')'"
    >
        <div class="login-card">
            <div class="logo-wrapper">
                <img
                        [src]="loginConfig.logoUrl || defaultLogoImageUrl"
                        alt="Logo"
                />
            </div>
            <div class="action-wrapper">
                <dx-button
                        class="login-btn"
                        [text]="'COMMON.TO-LOGIN' | translate"
                        type="normal"
                        (click)="onLoginClick()"
                ></dx-button>
                @if (companyLoginAvailable) {
                    <dx-button
                        class="login-btn"
                        [text]="'COMMON.COMPANY-LOGIN' | translate"
                        type="normal"
                        [disabled]="previewMode"
                        (click)="onCompanyLoginClick()"
                    ></dx-button>
                }
            </div>
        </div>
    </div>
}
